var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 715,
    viewBox: "0 0 1920 715",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480 410C480 553.594 363.594 670 220 670C76.406 670 -40 553.594 -40 410C-40 266.406 76.406 150 220 150C363.594 150 480 266.406 480 410Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 410C1920 553.594 1803.59 670 1660 670C1516.41 670 1400 553.594 1400 410C1400 266.406 1516.41 150 1660 150C1803.59 150 1920 266.406 1920 410Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971 312.5C971 485.089 831.089 625 658.5 625C485.911 625 346 485.089 346 312.5C346 139.911 485.911 0 658.5 0C831.089 0 971 139.911 971 312.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138 457.5C1138 550.008 1063.01 625 970.5 625C877.992 625 803 550.008 803 457.5C803 364.992 877.992 290 970.5 290C1063.01 290 1138 364.992 1138 457.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274 507C1274 572.17 1221.17 625 1156 625C1090.83 625 1038 572.17 1038 507C1038 441.83 1090.83 389 1156 389C1221.17 389 1274 441.83 1274 507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524 389C1524 474.604 1454.6 544 1369 544C1283.4 544 1214 474.604 1214 389C1214 303.396 1283.4 234 1369 234C1454.6 234 1524 303.396 1524 389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40 410H1920V819H-40V410Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1917 541.272H1420.24C1433.38 466.671 1497.82 409.945 1575.49 409.442C1610.59 337.321 1684.16 287.669 1769.23 287.669C1826.42 287.669 1878.4 310.102 1917 346.714V541.272ZM56.596 380.71C38.4879 373.15 19.4221 368.291 0 366.255V541.272H1343.22C1323.91 521.987 1297.34 510.075 1268.02 510.075C1261.19 510.075 1254.51 510.721 1248.03 511.955C1211.66 448.281 1143.46 405.413 1065.33 405.413C993.324 405.413 929.753 441.828 891.758 497.385C865.002 476.329 831.333 463.782 794.757 463.782C759.804 463.782 727.507 475.239 701.36 494.631C688.606 459.596 655.217 434.598 616.036 434.598C608.811 434.598 601.783 435.447 595.045 437.054C536.226 350.497 437.439 293.707 325.491 293.707C231.843 293.707 147.404 333.448 87.8684 397.11C77.9601 390.753 67.4989 385.261 56.596 380.71ZM1917 715V541.272H0.000732422V715H1917Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920 541.089C1900.55 543.112 1881.45 547.94 1863.32 555.453C1852.4 559.976 1841.92 565.433 1831.99 571.75C1772.37 508.489 1687.79 469 1594 469C1481.88 469 1382.93 525.431 1324.02 611.44C1317.28 609.844 1310.24 609 1303 609C1263.76 609 1230.32 633.84 1217.54 668.654C1191.35 649.385 1159.01 638 1124 638C1087.37 638 1053.65 650.467 1026.85 671.39C988.792 616.185 925.122 580 853 580C774.748 580 706.445 622.597 670.015 685.869C663.531 684.642 656.841 684 650 684C620.626 684 594.016 695.836 574.681 715H1920V541.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.542 715H0V521.671C38.6587 485.292 90.7261 463 148 463C233.208 463 306.892 512.338 342.043 584.003C419.837 584.503 484.373 640.871 497.542 715Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1446.84 624.027H1965V715H1446.84V624.027Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1812.94 483.846H1965V715H1812.94V483.846Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1868.72 539.257C1868.72 607.085 1813.78 662.07 1746 662.07C1678.22 662.07 1623.28 607.085 1623.28 539.257C1623.28 471.429 1678.22 416.443 1746 416.443C1813.78 416.443 1868.72 471.429 1868.72 539.257Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1669.56 622.166C1669.56 654.482 1643.38 680.678 1611.09 680.678C1578.8 680.678 1552.62 654.482 1552.62 622.166C1552.62 589.851 1578.8 563.654 1611.09 563.654C1643.38 563.654 1669.56 589.851 1669.56 622.166Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1965 483.846C1965 525.182 1931.52 558.692 1890.21 558.692C1848.9 558.692 1815.42 525.182 1815.42 483.846C1815.42 442.51 1848.9 409 1890.21 409C1931.52 409 1965 442.51 1965 483.846Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1607.51 715C1608.1 710.604 1608.4 706.118 1608.4 701.561C1608.4 646.179 1563.54 601.284 1508.2 601.284C1452.86 601.284 1408 646.179 1408 701.561C1408 706.118 1408.3 710.604 1408.89 715H1607.51Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 601.73H-347V715H298.605V601.73Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-157.54 427.191H-347V715H-157.54V427.191Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-227.043 496.182C-227.043 580.635 -158.584 649.097 -74.1365 649.097C10.3114 649.097 78.77 580.635 78.77 496.182C78.77 411.73 10.3114 343.268 -74.1365 343.268C-158.584 343.268 -227.043 411.73 -227.043 496.182Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1083 599.413C21.1083 639.649 53.7241 672.266 93.9577 672.266C134.191 672.266 166.807 639.649 166.807 599.413C166.807 559.177 134.191 526.559 93.9577 526.559C53.7241 526.559 21.1083 559.177 21.1083 599.413Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-347 427.191C-347 478.658 -305.279 520.381 -253.815 520.381C-202.35 520.381 -160.629 478.658 -160.629 427.191C-160.629 375.723 -202.35 334 -253.815 334C-305.279 334 -347 375.723 -347 427.191Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4158 715C97.6827 709.527 97.3042 703.94 97.3042 698.267C97.3042 629.311 153.201 573.412 222.152 573.412C291.104 573.412 347 629.311 347 698.267C347 703.94 346.621 709.527 345.888 715H98.4158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestBackground);
export default __webpack_public_path__ + "static/media/test-background.bc1ed1b6cb082b3e56372ab40c5253b3.svg";
export { ForwardRef as ReactComponent };